import { useMutation, useQuery } from "@tanstack/react-query";
import {
  CreateDashboardPrintData,
  CreateWellLevelsPrintData,
  GetBarGraphData,
  GetPrintData,
  GetSummaryData,
  GetWellLevelsData,
  ProjectID,
  getAnalytes,
  getSites,
} from "../types/project";

export function useSites(project: ProjectID) {
  return useQuery({ queryKey: [project, "sites"], queryFn: () => getSites(project) });
}

export function useAnalytes(project: ProjectID, sites: string[], startDate: Date, endDate: Date, isDetected: boolean) {
  return useQuery({
    queryKey: [project, sites, isDetected, startDate, endDate, "analytes"],
    queryFn: () => getAnalytes(project, sites, startDate, endDate, isDetected),
  });
}

export function useDashboardData({
  analyte,
  sites,
  startDate,
  endDate,
  project,
}: {
  analyte: string;
  sites: string[];
  startDate: Date;
  endDate: Date;
  project: ProjectID;
}) {
  const query = useQuery({
    queryKey: [project, "dashboardData", analyte, sites, startDate, endDate],
    queryFn: () => GetBarGraphData(project, analyte, sites, startDate, endDate),
  });

  return query;
}

export function useWellLevelsData(startDate: Date, endDate: Date, sites: string[]) {
  const query = useQuery({
    queryKey: ["wellLevelsData", startDate, endDate, sites],
    queryFn: () => GetWellLevelsData(startDate, endDate, sites),
  });

  return query;
}

export function useCreateDashboardPrintData(
  project: ProjectID,
  analyte: string,
  sites: string[],
  startDate: Date,
  endDate: Date,
) {
  return useMutation({ mutationFn: () => CreateDashboardPrintData(project, analyte, sites, startDate, endDate) });
}

export function usePrintData(id: string) {
  return useQuery({ queryKey: ["printData", id], queryFn: () => GetPrintData(id) });
}

export function useCreateWellLevelsPrintData(startDate: Date, endDate: Date, sites: string[]) {
  return useMutation({ mutationFn: () => CreateWellLevelsPrintData(startDate, endDate, sites) });
}

export function useSummaryData(project: ProjectID) {
  return useQuery({ queryKey: [project, "summary"], queryFn: () => GetSummaryData(project) });
}
